import React, { useEffect, useState }  from 'react'
import BlueButton from '../components/BlueButton';
import { useStateContext } from '../context/StateContext';
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext';
import { AuthContext } from '../context/AuthContext';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { _CREATE, _FETCH, _UPDATE} from '../utils/patches';
import { blueColour, goldColour, lighterBlueColour, Tag } from './Home';
import FieldDropdown from '../whitaijiFrontendLibrary/components/FieldDropdown';
import RichEmail from '../whitaijiFrontendLibrary/textEditors/RichEmail'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv';
import { LeftDownIcon } from '../components/ShowHideIcons';
import format from 'date-fns/format'
import { successAlert } from '../utils/utils';
import { FiEdit } from "react-icons/fi";
import TestButton from '../components/TestButton';
import { Country, State, City }  from 'country-state-city';
import ViewLabelValueField from '../components/ViewLabelValueField';
import {scrapedPsyc} from '../data/scrapedPsyc';


function Crm() {
      const {user} = useAuthContext(AuthContext)

    
      const {apiUrl, hideTestButtons} = useStateContext(); 
      const [addProspect, setAddProspect] = useState(false)

      const { data: prospectsData, isLoading: prospectsDataLoading} = useQuery({
        queryKey: ['prospectsData'],
        enabled: !!user,
        queryFn: async () => await _FETCH({route: `${apiUrl}/prospects`, user})
      });
  

      const country = Country.getCountryByCode("GB")
      const cities = City.getCitiesOfCountry("GB")

      const convertedPsychData = !Array.isArray(scrapedPsyc) ? [] : scrapedPsyc?.map((item)=>{
        const firstName = item.fullname.split(" ")[0];
        const findCity = () => {
          if(!item?.address2_city) return

          const findCity = !Array?.isArray(cities) ? undefined : cities.find((x)=>x?.name?.trim().toLowerCase() == item?.address2_city?.trim()?.toLowerCase() || x?.name?.includes(item?.address2_city?.trim()?.toLowerCase()))
          if(findCity) return findCity
        
          return {
            countryCode: "GB",
            name: item?.address2_city,
          }
        }
        const newDoc = 
        {
              _id: item?.contactid,
              email: item?.workEmail,
              phoneNumber: item?.workPhone,
              website: item?.website, 
              firstName: firstName, 
              lastName: item?.lastname, 
              //professionalTitle: item?.salutation, 
              salutation: item?.salutation,
              prospectType: "Psychologist",
              language: "en",
              country: country || undefined,
              city: findCity() || undefined,  
              addressFirstLine: item?.address2_line1,
              addressSecondLine: item?.address2_line2,
              postCode: item?.address2_postalcode,
              typeOfTreatment: !Array?.isArray(item?.typeOfTreatment) ? [] : item?.typeOfTreatment
              
            }
          return newDoc
      }) 

          const consoleData = {prospectsData, scrapedPsyc, convertedPsychData, cities, country}
  return (
    <div>
      <TestButton buttonId='lqkpqojkdoqihjd' message='test crm' consoleData= {consoleData}/>
      <BlueButton fn={()=>setAddProspect(!addProspect)} hide={hideTestButtons} text={addProspect ? "Close" : "Add Prospect"} />
      <ProspectForm isVisible={addProspect}/>
      {!Array.isArray(prospectsData) ? [] : prospectsData?.map((p)=>{
        return (
          <ProspectPin key={p?._id} prospect={p}/>
      )})}
      <ImportProspectsFromPsych data={{psychData: scrapedPsyc, convertedPsychData}}/>
    </div>
  )
}

export default Crm

export const ProspectForm = ({initialDoc, isVisible=true}) => {

  const prospectTypes = [
    {label: "Psychologist", value: "Psychologist"},
    {label: "User", value: "User"},
  ]

  const queryClient = useQueryClient()
  const { user } = useAuthContext(AuthContext)
  const {apiUrl} = useStateContext()

  const [email, setEmail] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [professionalTitle, setProfessionalTitle] = useState('')
  const [prospectType, setProspectType] = useState(prospectTypes[0])

  const [error, setError] = useState(null)
  const [emptyFields, setEmptyFields] = useState([])


  const onError = (e) => {
    setError(e.error)
    setEmptyFields(e.emptyFields)
  }
  useEffect(() => {
    if(initialDoc){
      setEmail(initialDoc?.email);
      setFirstName(initialDoc?.firstName);
      setLastName(initialDoc?.lastName);  
      setProfessionalTitle(initialDoc?.professionalTitle)
      if(initialDoc?.prospectType){
        setProspectType({label: initialDoc?.prospectType, value: initialDoc?.prospectType})
      }
      
    }
  }, [initialDoc])

  const resetFields = () => {
    setEmail('')
    setFirstName('')
    setLastName('')
    setError(null)
    setEmptyFields([])
    setProfessionalTitle('')
    successAlert("Prospect Added")
    setProspectType(undefined)
  }
  const onSuccess = (json) => {
    if(!initialDoc){
      resetFields()
    }
    //dispatch({type: 'CREATE_DOCUMENT', payload: json})
    successAlert(!initialDoc ? "Prospect Added" : "Prospect Updated")
  }
  const { mutate: createProspect } = useMutation({  
    mutationFn: async(doc) => {
      return await _CREATE({doc, user, route: `${apiUrl}/prospects`, onError, onSuccess})
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['prospectsData'] }),
    mutationKey:['prospectsData'],

  })
  const { mutate: editProspect } = useMutation({  
    mutationFn: async(doc) => {
      return await _UPDATE({doc, user, route: `${apiUrl}/prospects/${initialDoc._id}`, onError, onSuccess})
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['prospectsData'] }),
    mutationKey:['prospectsData'],

  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!user) {
      setError('You must be logged in')
      return
    }

    const doc = {email, firstName, lastName, professionalTitle, prospectType: prospectType.value}

    console.log("Submitting Prospect", {doc})
    if(!initialDoc){
      console.log("Creating Prospect", {doc})
      createProspect(doc)
      return
    }
    if(initialDoc) {
       console.log("Updating Prospect", {doc})
      editProspect(doc)
      return
    }
    

  }
  return (
    <VisDiv rules={[isVisible]} style={{padding:"15px"}}>
      <form className="create" onSubmit={handleSubmit}>
        <label onClick={()=>console.log("jkskjdh", {email, firstName, lastName, professionalTitle})}>Email:</label>
        <input 
          type="text"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          className={emptyFields?.includes('email') ? 'error' : ''}
        />

        <label>First Name:</label>
        <input 
          type="text"
          onChange={(e) => setFirstName(e.target.value)}
          value={firstName}
          className={emptyFields?.includes('firstName') ? 'error' : ''}
        />

        <label>Last Name:</label>
        <input 
          type="text"
          onChange={(e) => setLastName(e.target.value)}
          value={lastName}
          className={emptyFields?.includes('lastName') ? 'error' : ''}
        />
        <label>Professional Title</label>
        <input 
          type="text"
          onChange={(e) => setProfessionalTitle(e.target.value)}
          value={professionalTitle}
          className={emptyFields?.includes('professionalTitle') ? 'error' : ''}
        />
        <label>Prospect Type</label>
      
        <FieldDropdown
          onChange={(e) => setProspectType(e)}
          initialValue={prospectType}
          options = {prospectTypes}
          placeHolder="Select Prospect Type"
        />


        <button>Save</button>
        {error && <div className="error">{error}</div>}
      </form>
    </VisDiv>
  )
}

export const ProspectPin = ({prospect}) => {

    const {apiUrl, hideTestButtons} = useStateContext();
    const [edit, setEdit] = useState(false)
    const {user} = useAuthContext(AuthContext)
    const [showInfoData, setShowInfoData] = useState(false)
    const prospectName = `${prospect?.firstName} ${prospect?.lastName}`
    const email = prospect?.email
    const [showSendEmail, setShowSendEmail] = useState(false)
    const [showViewEmails, setShowViewEmails] = useState(false)
    const valueDistance = 3
    
    // Count empty properties

    const emptyPropertiesCount = countEmptyProperties(prospect)?.emptyCount;
    
      const { data: emailsData, isLoading: emailsDataLoading} = useQuery({
        queryKey: ['emailsData', showViewEmails],
        enabled: !!showViewEmails,
        queryFn: async () => await _FETCH({route: `${apiUrl}/email/${email}`, user})
      });
    const testFunction = () => {
        process.env.NODE_ENV === "development" && console.log("emailsData", {emailsData})
      }
    const areThereEmails = emailsData?.length ? true : false
    const nEmails = emailsData?.length
  return (
    <div style={{padding: "10px", border: "1px solid #ccc", margin: "10px", borderRadius: "10px"}}>
        <div style={{display:"flex", alignItems:"center"}}>
          <TestButton buttonId="qdlqdqldopè" message="View Prospect" consoleData={{prospect}}/>
          <FiEdit 
            style={{cursor: 'pointer', marginRight: '10px'}} 
            size={20} 
            onClick={() => setEdit(!edit)}
          />
          <h2 style={{marginRight: "10px"}}>{prospectName}</h2>
        </div>
        <ProspectForm isVisible={edit} initialDoc={prospect}/>
        <div style={{marginTop: "10px"}}>
            {prospect?.prospectType && <Tag text={prospect?.prospectType} />}
        </div>
          <div style={{display: "flex", alignItems: "center", marginTop: "10px"}}>
          <LeftDownIcon show={showInfoData} setShow={setShowInfoData}/>
          <h4>Info</h4>
          {emptyPropertiesCount > 0 && (
            <div style={{marginLeft: "10px", backgroundColor: "red", width: "30px", height: "30px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center"}}>
              <h4 style={{color: "white"}}>{emptyPropertiesCount}</h4>
            </div>
          )}
        </div>
        <VisDiv rules={[emptyPropertiesCount > 0 ]} style={{display: "flex", alignItems: "center", marginTop: "10px"}}>
          <h4 style={{marginRight: "10px"}}>Missing Properties:</h4>
          <p>{countEmptyProperties(prospect)?.emptyProperties.join(', ')}</p>
        </VisDiv>
        <VisDiv rules={[showInfoData]}>
          <ViewLabelValueField label={"Email"} value={email} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Phone Number"} value={prospect?.phoneNumber} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Website"} value={prospect?.website} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"First Name"} value={prospect?.firstName} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Last Name"} value={prospect?.lastName} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Professional Title"} value={prospect?.professionalTitle} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Salutation"} value={prospect?.salutation} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Prospect Type"} value={prospect?.prospectType} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Language"} value={prospect?.language} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Country"} value={prospect?.country?.name} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"City"} value={prospect?.city?.name} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Address First Line"} value={prospect?.addressFirstLine} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Address Second Line"} value={prospect?.addressSecondLine} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Post Code"} value={prospect?.postCode} labelValueDistance={valueDistance} />
          <ViewLabelValueField label={"Type of Treatment"} value={prospect?.typeOfTreatment?.join(", ")} labelValueDistance={valueDistance} />
        </VisDiv>
        <div style={{display: "flex", alignItems: "center", marginTop: "10px"}}>
          <LeftDownIcon show={showSendEmail} setShow={setShowSendEmail}/>
          <h4>Send Email</h4>
        </div>
        <VisDiv rules={[showSendEmail]}>
            <RichEmail emailTemplate={{toEmail: prospect?.email}}/>
        </VisDiv>
        <VisDiv rules={[true]} style={{display: "flex", alignItems: "center", marginTop: "10px"}}>
          <LeftDownIcon show={showViewEmails} setShow={setShowViewEmails}/>
          <h4>View Emails</h4>
          <div style={{marginLeft: "10px",  backgroundColor: blueColour, width: "30px", height: "30px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center"}}>
              <h4 style={{color: "white",}}>{nEmails}</h4>
          </div>
         
        </VisDiv>
        <VisDiv rules={[showViewEmails]}>
          <BlueButton fn={testFunction} />
          {!Array.isArray(emailsData) ? [] : emailsData?.map((email)=>{
            return (
              <EmailPin key={email?._id} email={email}/>
            )
          })}
        </VisDiv>
       
      
    </div>
  )
}

export const EmailPin = ({email}) => {
  const seenAt = email?.seenAt && format(email?.seenAt, "dd/MM/yyyy HH:mm"); 
  const createdAt = email?.createdAt && format(email?.createdAt, "dd/MM/yyyy HH:mm"); 
  const [viewEmail, setViewEmail] = useState(false)
  return (
    <div style={{padding: "10px", border: "1px solid #ccc", margin: "10px", borderRadius: "10px"}}>
        <h4 onClick={() => console.log("email", {email})} style={{marginBottom: "10px"}}>{email?.subject}</h4>
        <div style={{marginBottom:"10px"}}>
          {createdAt && <Tag color={blueColour} text ={`Sent: ${createdAt}`}/>}
        </div>
        {seenAt && <Tag text ={`Opened: ${seenAt}`}/>}
        <div style={{display: "flex", alignItems: "center", marginTop: "10px"}}>
          <LeftDownIcon show={viewEmail} setShow={setViewEmail}/>
          <h4>View Email</h4>
        </div>
        <VisDiv rules={[viewEmail]}>
          <div dangerouslySetInnerHTML={{ __html: email?.htmlBody }} style={{marginTop: "10px"}}></div>
        </VisDiv>
  </div>
  )
}

const ImportProspectsFromPsych = ({data = {}}) => {
 const {psychData, convertedPsychData} = data
 const [psychFilter, setPsychFilter] = useState(); 
 const fields = [
  'email', 
  'phoneNumber', 
  'website', 
  'firstName', 
  'lastName', 
  //'prospectType', 
  //'language',
  'country', 
  'city'
];

const options = fields.map(f => ({ label: f, value: f }));

const prospectFiltered = !Array.isArray(convertedPsychData) ? [] : convertedPsychData.filter(item => {
    const emptyProperties = countEmptyProperties(item);
    if(!psychFilter) return item;
    return emptyProperties?.emptyProperties?.includes(psychFilter?.label);
  })
const nProspectsFiltered = prospectFiltered.length

const save = () => {

}

  return (
    <div style={{padding: "20px"}}>
      <h4>IMPORT PSYCH</h4>
      <BlueButton color ={"green"} hoverColor={goldColour} text='Save' fn={save} />
      <div style={{ marginBottom: "10px"}}>
        <FieldDropdown 
          options={options} 
          onChange={(e) => setPsychFilter(e)}
          value={psychFilter}
          placeHolder={"Filter by missing property"}
        />
        <VisDiv rules={[psychFilter]} style={{maxWidth: "150px", backgroundColor: blueColour, padding: "5px 10px", borderRadius: "5px"}}>
          <h4 style={{color: "white", margin: 0}}>Filtered: {nProspectsFiltered}</h4>
        </VisDiv>
        <VisDiv rules={[!psychFilter]} style={{maxWidth: "150px", backgroundColor: "green", padding: "5px 10px", borderRadius: "5px"}}>
          <h4 style={{color: "white", margin: 0}}># Prospects: {nProspectsFiltered}</h4>
        </VisDiv>
      </div>
      {!Array.isArray(prospectFiltered) ? [] : prospectFiltered?.map((item, index)=>{
        return <ProspectPin key={index} prospect={item}/>
      })}
    </div>
  )
}
   export const countEmptyProperties = (prospect) => {
      const propertiesToCheck = [
        'email', 
        'phoneNumber', 
        'website', 
        'firstName', 
        'lastName', 
       // 'professionalTitle', 
       // 'salutation', 
        'prospectType', 
        'language',
        'country', 
        'city', 
       // 'addressFirstLine', 
       // 'addressSecondLine', 
       // 'postCode'
      ];
      
      let emptyCount = 0;
      let emptyProperties = [];
      
      propertiesToCheck.forEach(prop => {
        if (!prospect?.[prop] || prospect?.[prop] === '') {
          emptyCount++;
          emptyProperties.push(prop);
        }
      });
      
      // Special check for typeOfTreatment array
      if (!Array.isArray(prospect?.typeOfTreatment) || prospect?.typeOfTreatment.length === 0) {
        emptyCount++;
        emptyProperties.push('typeOfTreatment');
      }
      
      return {emptyCount, emptyProperties};
    };


